import { Grid, Typography } from '@mui/material';
import {
  Datagrid,
  FunctionField,
  ListContextProvider,
  ShowButton,
  SimpleShowLayout,
  TextField,
  useList,
  useRecordContext,
} from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { AccountStatusChip, PhoneNumberArrayField } from 'src/lib';
import { Account, UserDetails } from 'src/models';
import { Spacing } from 'src/styles';

export const UserAccountList = () => {
  const record = useRecordContext<UserDetails>();

  const listContext = useList({
    data: record?.accounts || [],
    isLoading: false,
    resource: DataProviderResource.Accounts,
  });

  return (
    <Grid container className={Spacing.my32}>
      <Grid item xs={12} md={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Accounts</Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item xs={12} md={12}>
        <ListContextProvider
          value={{
            ...listContext,
          }}>
          <Datagrid
            resource={DataProviderResource.Accounts}
            bulkActionButtons={false}
            empty={
              <SimpleShowLayout>
                <Typography>No accounts found</Typography>
              </SimpleShowLayout>
            }>
            <TextField source='id' label='Id' />
            <TextField source='accountId' label='Account Id' />
            <TextField source='accountNumber' label='Account number' />
            <TextField source='type.label' label='Type' />
            <TextField source='primaryAccountHolder.firstName' label='First Name' />
            <TextField source='primaryAccountHolder.middleName' label='Middle Name' />
            <TextField source='primaryAccountHolder.lastName' label='Last Name' />
            <TextField source='primaryAccountHolder.suffix' label='Suffix' />
            <TextField source='primaryAccountHolder.email' label='Email' />
            <FunctionField
              render={(record: Account) => {
                return <PhoneNumberArrayField record={record?.primaryAccountHolder?.phones} />;
              }}
              label='Phone Number'
            />
            <FunctionField
              label='Status'
              render={(account: Account) => {
                if (account?.status) {
                  return <AccountStatusChip value={account.status} />;
                }

                return null;
              }}
            />
            <ShowButton label='Show' resource={DataProviderResource.Accounts} />
          </Datagrid>
        </ListContextProvider>
      </Grid>
    </Grid>
  );
};
